import usePushNotifications from "hooks/usePushNotifications";
import { Outlet } from "react-router";

const PushNotificationsLayout = () => {
  usePushNotifications();
  return <Outlet />;
};

export default PushNotificationsLayout;
